import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        //查询公告列表
        querynoticelist(context, payload) {
            return D.select({
                ...payload
            })
        },

        editnotice(context, payload) {
            return D.select({
                ...payload
            })
        },

        addnotice(context, payload) {
            return D.select({
                ...payload
            })
        },

        deletenotice(context, payload) {
            return D.select({
                ...payload
            })
        },

        detailnotice(context, payload) {
            return D.select({
                ...payload
            })
        }
        
    }
}